import React from "react";

export const Background = ({ children }) => {
  return (
    <body className="dark:bg-slate-900 bg-white transition-all h-screen overflow-y-scroll">
      {children}
    </body>
  );
};
